import { selectCustomDataPackageType } from '../../selectors/customData';
import { createPackage } from '../../models/packages';
import { TAppState } from '../../types';
import { IUserBalance } from '../../thunks/buyPackageWithHold';
import { IPackageContext, IPackageContextExtra } from './types';

export const packageContext: IPackageContext = {
  buy: async (state: TAppState, extra: IPackageContextExtra) => {
    const { httpApi } = extra;

    const packageType = selectCustomDataPackageType(state)!;
    const userPackage = createPackage(packageType);

    userPackage.trackConfirm(state);

    const parameters = userPackage.getParams(state);

    return userPackage.buy({ httpApi, parameters });
  },

  buyWithHold: async (state: TAppState, userBalance: IUserBalance, extra: IPackageContextExtra) => {
    const { httpApi } = extra;

    const packageType = selectCustomDataPackageType(state)!;
    const userPackage = createPackage(packageType);

    const params = userPackage.getParams(state);

    const parameters = {
      ...userBalance,
      ...params,
      needHold: true,
    };

    return userPackage.buyWithHold({ httpApi, parameters });
  },

  trackCancel: (state: TAppState) => {
    const packageType = selectCustomDataPackageType(state)!;
    const userPackage = createPackage(packageType);

    userPackage.trackCancel(state);
  },
};
